import { RootState } from '@app/redux/root-reducer';

export const selectAboutUsState = (store: RootState) => store.aboutUsReducer.aboutUs;
export const selectAddAboutUsState = (store: RootState) => store.aboutUsReducer.addAboutUs;
